let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("9J4QP")).then(() => parcelRequire('9VAR9'));